import React, { Fragment } from "react";

import InsuranceType from "./InsuranceType";
import InlineTerm from "../InlineTerm";

const EligibilityCriteria = ({ fpl, title, data, eligibilityCriteria }) => {
  return (
    <div className="u-richtext f-scale-body">
      <h2>Eligibility Criteria</h2>
      <p>To get financial assistance for {title}, you must:</p>

      <div
        className="u-richtext f-scale-body"
        dangerouslySetInnerHTML={{ __html: eligibilityCriteria }}
      ></div>
      {/* <ol>
        {(data.eligibilityCriteria.map((criteria, i) => (
          <Fragment key={i}>
            {criteria.publicDescription && (
              <li>
                {criteria.publicDescription}
              </li>
            )}
          </Fragment>
        )))}
      </ol> */}
      <p className="f-h5">Calculate Your Federal Poverty Level Percentage</p>
      <a
        target="_blank"
        href="https://www.needymeds.org/federal-poverty-level-calculator"
        className="btn"
      >
        Calculate Percentage
      </a>
    </div>
  );
};

export default EligibilityCriteria;
